import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ label, value, icon, color, trend, trendValue }) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border elevation-1 hover:elevation-2 transition-all duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg bg-${color}/10 flex items-center justify-center`}>
          <Icon name={icon} size={24} color={`var(--color-${color})`} />
        </div>
        <span className="text-3xl font-semibold text-foreground">{value}</span>
      </div>
      <p className="text-sm text-muted-foreground mb-2">{label}</p>
      {trend && (
        <div className="flex items-center gap-1">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'} 
          />
          <span className={`text-xs font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground">vs last month</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;